<form class="create-report-modal-molecule-root">
  <button id="close-create-report-icon" (click)="onFailClick()" mat-icon-button class="close-button">
    <mat-icon>cancel</mat-icon>
  </button>

  <app-header>{{ labels.createAReport }}</app-header>
  <div mat-dialog-content>
    <app-label isGray class="label">{{ labels.date }}</app-label>
    <div class="date-filters">
      <app-chip id="last-3-months"
                small
                (selectFilterClick)="last3Months()"
                [active]="!!activeFilter.last3Months"
                gray>
        {{ labels.last3Months }}
      </app-chip>
      <app-chip id="last-6-months"
                small
                (selectFilterClick)="last6Months()"
                [active]="!!activeFilter.last6Months"
                gray>
        {{ labels.last6Months }}
      </app-chip>
      <app-chip id="last-year"
                small
                (selectFilterClick)="lastYear()"
                [active]="!!activeFilter.lastYear"
                gray>
        {{ labels.lastYear }}
      </app-chip>
    </div>
    <app-label isGray class="label">{{ labels.dateRange }}</app-label>
    <div class="date-picker-group">
      <div>
        <app-input id="starting-date-input"
                   [label]="labels.startingDate + ':'"
                   [control]="form.controls['startingDate']"
                   [datepicker]="startingDate">
        </app-input>
        <mat-datepicker #startingDate></mat-datepicker>
      </div>
      <div>
        <app-input id="ending-date-input"
                   [label]="labels.endingDate + ':'"
                   [control]="form.controls['endingDate']"
                   [datepicker]="endingDate">
        </app-input>
        <mat-datepicker #endingDate></mat-datepicker>
      </div>
    </div>
    <app-label isGray class="label">{{labels.include}}</app-label>
    <div class="include-section">
      <app-checkbox id="added-points-checkbox"
                    [formGroup]="form"
                    abstractFormControlName="includeAddedPoints">
                    {{ labels.addedPoints }}
      </app-checkbox>
      <app-checkbox id="redeemed-points-checkbox"
                    [formGroup]="form"
                    abstractFormControlName="includeRedeemedPoints">
                    {{ labels.redeemedPoints }}
      </app-checkbox>
      <app-checkbox id="expired-points-checkbox"
                    [formGroup]="form"
                    abstractFormControlName="includeExpiredPoints">
                    {{ labels.expiredPoints }}
      </app-checkbox>
      <app-checkbox id="removed-points-checkbox"
                    [formGroup]="form"
                    abstractFormControlName="includeRemovedPoints">
                    {{ labels.removedPoints }}
      </app-checkbox>
    </div>
    <mat-error id="at-least-one-filter-error" *ngIf="form.errors?.['message']">
      {{ labels.atLeastOneFilterRequired }}
    </mat-error>
    </div>
  <div mat-dialog-actions>
    <app-primary-button class="success-button"
                        id="create-report-btn"
                        mat-button
                        type="submit"
                        [abstractControl]="form"
                        [disabled]="loading"
                        (clickAction)="createReport()">
      {{ labels.createReport }}
    </app-primary-button>
    <app-primary-button id="fail-dialog-btn"
                        mat-button
                        [disabled]="loading"
                        (clickAction)="onFailClick()">
      {{ labels.cancel }}
    </app-primary-button>
  </div>
</form>
